<template>
    <div>
        <div class="lg:mx-auto flex items-center justify-between">
            <!-- Avatar e Informações -->
            <div class="flex items-center h-16 gap-2" v-if="title">
                <div class="flex-shrink-0" v-if="avatar || forceAvatar">
                    <div class="relative">
                        <Avatar :avatar="avatar" :size="avatarSize" class="border rounded-full " />
                        <span class="absolute inset-0 rounded-full" aria-hidden="true" />
                    </div>
                </div>
                <div class="min-w-0 shrink-0">
                    <div v-if="sub" class="text-xs -mb-1 break-words">{{ sub }}</div>
                    <h1 class="text-lg font-medium break-words">{{ title }}</h1>
                    <p v-if="subTitle" class="-mt-1 text-sm break-words">{{ subTitle }}</p>
                </div>
            </div>

            <!-- Placeholder (carregando) -->
            <div class="flex items-center gap-2 h-16" v-else>
                <div class="ghost rounded-full h-12 w-16"></div>
                <div class="w-full">
                    <div class="ghost h-4 w-[180px] rounded mb-2"></div>
                    <div class="ghost h-3 w-[100px] rounded"></div>
                </div>
            </div>

            <!-- Conteúdo adicional -->
            <div
                class="flex flex-col-reverse justify-end space-y-4 space-y-reverse sm:space-y-0 sm:flex-row-reverse sm:justify-end sm:space-x-3"
                :class="contentClass"
            >
                <slot />
            </div>
        </div>
    </div>
</template>

<script>

import { HomeIcon } from '@heroicons/vue/24/outline'

export default {
    name: "PageSubHeaderAvatar",
    props: {
        title: {
            type: String,
            default: '',
            required: false,
        },
        sub: {
            type: String,
            default: '',
            required: false,
        },
        subTitle: {
            type: String,
            default: '',
            required: false,
        },        
        avatar: {
            type: String,
            required: false,
        },
        forceAvatar: {
            type: Boolean,
            default: false,
            required: false,
        },
        avatarSize: {
            type: String,
            default: 'lg',
            required: false,
        },
        
        contentClass: String,
    },

    data() {
        return {
            pages: [],
        }        
    },
    components: {
        HomeIcon,
    },
    created() {
        // Se habilito isso está dando problemas em várias áreas do sistema
        // entender melhor
        //this.pages = this.$RouteService.getOptionArrayOrRoute(this.$route.path);
    },

}
</script>

<style scoped>
    h3 {
     font-size: 1.5rem;
     text-transform: capitalize;
    }

</style>